import type { PersonKind } from "@verde/entities";
import { lazy } from "@verde/utils";
import { ErrorBoundary } from "components/error-boundary";
import React, { createElement, useMemo } from "react";
import { Loadable } from "utils/routes";
import { useCreditProfilePanel } from "./panel";

const PanelDataResume = Loadable(lazy(() => import("./panel-data-resume")));
const PanelDataDebts = Loadable(lazy(() => import("./panel-data-debts")));
const PanelDataSerasaPF = Loadable(
  lazy(() => import("./panel-data-serasa-pf")),
);
const PanelDataSerasaPJ = Loadable(
  lazy(() => import("./panel-data-serasa-pj")),
);
const PanelDataProperties = Loadable(
  lazy(() => import("./panel-data-properties")),
);
const PanelDataPartners = Loadable(lazy(() => import("./panel-data-partners")));

function PanelData() {
  const { client, currentTab } = useCreditProfilePanel();

  const renderSerasa = useMemo(() => {
    return client?.person_kind === "COMPANY"
      ? PanelDataSerasaPJ
      : PanelDataSerasaPF;
  }, [client?.person_kind]);

  return (
    <ErrorBoundary>
      {createElement(
        {
          resume: PanelDataResume,
          debts: PanelDataDebts,
          serasa: renderSerasa,
          properties: PanelDataProperties,
          partners: PanelDataPartners,
          default: null,
        }[currentTab || "default"],
      )}
    </ErrorBoundary>
  );
}

export default React.memo(PanelData);
